import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { useDebounce } from '@fuse/hooks';
import React from 'react';
import { BiTransfer } from 'react-icons/bi';

const TransferenciaSearchHeader = ({ fetch, initialPage }) => {
  const pesquisar = useDebounce(
    (value) => {
      initialPage.query = value;
      fetch(initialPage);
    },
    500,
    {}
  );

  return (
    <>
      <PageHeader title="Transferências" icon={<BiTransfer />}>
        <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar onChange={pesquisar} placeholder="Pesquisar" />
        </div>
      </PageHeader>
    </>
  );
};

export default TransferenciaSearchHeader;
